import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchSingleQueryStatus = async (queryId) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/ecrf/get_query_logs/?queryId=${queryId}`, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data;
};

const useGetSingleQueryStatus = ({ queryId, enabled = false }) => {
  return useQuery({
    queryKey: ["single_query_status", queryId],
    queryFn: () => fetchSingleQueryStatus(queryId),
    enabled: enabled && Boolean(queryId),
  });
};

export default useGetSingleQueryStatus;
